// Placeholder user photo. Replace with actual user photo if available.
export default 'https://randomuser.me/api/portraits/men/32.jpg';
